var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageleftarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.39701 16.1021C9.45227 16.1536 9.4966 16.2157 9.52734 16.2847C9.55808 16.3537 9.57462 16.4282 9.57595 16.5037C9.57728 16.5793 9.56339 16.6543 9.5351 16.7243C9.50681 16.7944 9.4647 16.858 9.41128 16.9114C9.35787 16.9648 9.29424 17.0069 9.2242 17.0352C9.15416 17.0635 9.07914 17.0774 9.00361 17.0761C8.92809 17.0748 8.8536 17.0582 8.7846 17.0275C8.7156 16.9967 8.6535 16.9524 8.602 16.8971L1.10201 9.39714C0.996667 9.29167 0.9375 9.1487 0.9375 8.99964C0.9375 8.85058 0.996667 8.70761 1.10201 8.60214L8.602 1.10214C8.70864 1.00278 8.84967 0.948688 8.9954 0.95126C9.14112 0.953831 9.28016 1.01286 9.38322 1.11592C9.48628 1.21898 9.54531 1.35802 9.54789 1.50375C9.55046 1.64947 9.49637 1.79051 9.39701 1.89714L2.29544 8.99964L9.39701 16.1021Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageleftarrow);
export default __webpack_public_path__ + "static/media/page left arrow.4edc3f67c43c6b34b5f33988882cec40.svg";
export { ForwardRef as ReactComponent };